
export const STCblue ='#00a2e5';
export const STCbluestrong ='#00a2e5';
export const STCbluedark ='#025579';
export const STCgreen ='#abcd50';
export const STCgreenstrong ='#83a720';
export const STCgreendark ='#577504';
export const PassengersClr = "#ff4747";
export const MyAccountClr = "#ffc100";
export const PaymentHistoryClr = "#71c02b";